import Utils from '../utils';

export default {
    data() {
        return {
            wxPrepared: false,
        };
    },
    computed: {
        isWxBrowser() {
            return Utils.env.isWxBrowser();
        },
    },
    methods: {
        prepareWx() {
            if (this.wxPrepared) {
                return Promise.resolve(window.wx);
            }
            return this.$api.wx.getSignature().then(Utils.wx.config).then(() => {
                this.wxPrepared = true;
                return window.wx;
            }).catch((err) => {
                // ChangWei
                // eslint-disable-next-line no-console
                console.error(err);
                this.wxPrepared = false;
            });
        },
        async hideWxAllMenuItems() {
            if (this.isWxBrowser) {
                await this.prepareWx();
                await Utils.wx.hideAllMenuItems();
            }
        },
        async showWxOpenWithMenuItems() {
            if (this.isWxBrowser) {
                await this.prepareWx();
                await Utils.wx.showOpenWithMenuItems();
            }
        },
        async showWxCopyUrlMenuItems() {
            if (this.isWxBrowser) {
                await this.prepareWx();
                await Utils.wx.showCopyUrlMenuItems();
            }
        },
        async showWxShareMenuItems() {
            if (this.isWxBrowser) {
                await this.prepareWx();
                await Utils.wx.showShareMenuItems();
            }
        },
        async updateWxShareMenuItems(imgUrl, title, description, link) {
            if (this.isWxBrowser) {
                await this.prepareWx();
                await Utils.wx.updateShareMenuItems(imgUrl, title, description, link);
            }
        },
    },
};
